module.exports = __webpack_public_path__ + "img/case-page.31e8282c.png";